import $ from 'jquery'
globalThis.jQuery = $;
window.$ = window.jQuery = jQuery = $;